import React, { Component } from 'react';
import './Button.css';
import throttle from 'lodash.throttle';

export default class Button extends Component {
	getClasses = () => {
		return (
			(this.props.className || '') +
			this.getCenterClass() +
			' g-button ' +
			this.getColor() +
			' ' +
			this.getBackground() +
			' ' +
			this.getDisabled()
		);
	};

	getCenterClass = () => {
		if (this.props.center) {
			return ' center ';
		}
		return ' ';
	};

	getColor = () => {
		if (this.props.color) {
			return 'g-' + this.props.color;
		}
		return '';
	};

	getBackground = () => {
		if (this.props.bg) {
			return 'bg-' + this.props.bg;
		}
		return '';
	};

	getDisabled = () => {
		if (this.props.disabled) {
			return 'disabled';
		}
		return '';
	};

	onClick = throttle(() => {
		if (this.props.disabled) return;
		else if (this.props.onClick) {
			this.props.onClick();
		}
	}, 400,  { leading: true, trailing: false }); // allow first click but ignore others until after 300 ms.

	render() {
		// eslint-disable-next-line
		let { className, color, bg, onClick, ...props } = { ...this.props };
		return (
			<a onClick={this.onClick} onKeyDown={this.props.onKeyDown} tabIndex={0} className={this.getClasses()} onBlur={this.props.onBlur} {...props}>
				{this.props.children}
			</a>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/button/Button.jsx